/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeagueStanding } from './LeagueStanding';
import {
    LeagueStandingFromJSON,
    LeagueStandingFromJSONTyped,
    LeagueStandingToJSON,
    LeagueStandingToJSONTyped,
} from './LeagueStanding';

/**
 * 
 * @export
 * @interface GetLeagueStandingsResponse
 */
export interface GetLeagueStandingsResponse {
    /**
     * 
     * @type {Array<LeagueStanding>}
     * @memberof GetLeagueStandingsResponse
     */
    standings: Array<LeagueStanding>;
}

/**
 * Check if a given object implements the GetLeagueStandingsResponse interface.
 */
export function instanceOfGetLeagueStandingsResponse(value: object): value is GetLeagueStandingsResponse {
    if (!('standings' in value) || value['standings'] === undefined) return false;
    return true;
}

export function GetLeagueStandingsResponseFromJSON(json: any): GetLeagueStandingsResponse {
    return GetLeagueStandingsResponseFromJSONTyped(json, false);
}

export function GetLeagueStandingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeagueStandingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'standings': ((json['standings'] as Array<any>).map(LeagueStandingFromJSON)),
    };
}

export function GetLeagueStandingsResponseToJSON(json: any): GetLeagueStandingsResponse {
    return GetLeagueStandingsResponseToJSONTyped(json, false);
}

export function GetLeagueStandingsResponseToJSONTyped(value?: GetLeagueStandingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'standings': ((value['standings'] as Array<any>).map(LeagueStandingToJSON)),
    };
}

